export default "__VITE_ASSET__BYn_TcyM__"